"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
        throw new TypeError("attempted to use private field on non-instance");
    }
    return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
    return "__private_" + id++ + "_" + name;
}
var packageJson = {
    "version": "2.1.1"
};
/**
 * Default store that keeps state in a simple object.
 */ var _publish = /*#__PURE__*/ _classPrivateFieldLooseKey("publish");
var DefaultStore = /*#__PURE__*/ function() {
    function DefaultStore() {
        _class_call_check(this, DefaultStore);
        Object.defineProperty(this, _publish, {
            value: _publish2
        });
        this.state = {};
        this.callbacks = []; // TODO: use a Set instead, make it a private prop
    }
    _create_class(DefaultStore, [
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "setState",
            value: function setState(patch) {
                var prevState = _object_spread({}, this.state);
                var nextState = _object_spread({}, this.state, patch);
                this.state = nextState;
                _classPrivateFieldLooseBase(this, _publish)[_publish](prevState, nextState, patch);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(listener) {
                var _this = this;
                this.callbacks.push(listener);
                return function() {
                    // Remove the listener.
                    _this.callbacks.splice(_this.callbacks.indexOf(listener), 1);
                };
            }
        }
    ]);
    return DefaultStore;
} // TODO: export the class instead in the next major.
();
function _publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    this.callbacks.forEach(function(listener) {
        listener.apply(void 0, _to_consumable_array(args));
    });
}
DefaultStore.VERSION = packageJson.version;
function defaultStore() {
    return new DefaultStore();
}
module.exports = defaultStore;
